export default __webpack_public_path__ + "static/media/logo.45654399.png";